"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscardedRulingSchema = exports.RulingDiscardReasonSchema = exports.RulingDiscardReason = exports.DiscardedRulingKindSchema = exports.DiscardedRulingKind = void 0;
const z = require("zod");
const consensus_types_1 = require("../../../../Consensus/consensus.types");
const json_value_1 = require("../../../../Utils/json-value");
var DiscardedRulingKind;
(function (DiscardedRulingKind) {
    DiscardedRulingKind["GroundTruth"] = "ground_truth";
    DiscardedRulingKind["Error"] = "error";
    DiscardedRulingKind["Signal"] = "signal";
})(DiscardedRulingKind || (exports.DiscardedRulingKind = DiscardedRulingKind = {}));
exports.DiscardedRulingKindSchema = z.nativeEnum(DiscardedRulingKind);
var RulingDiscardReason;
(function (RulingDiscardReason) {
    RulingDiscardReason["RowRemoved"] = "row_removed";
    RulingDiscardReason["RowNotOnPackage"] = "row_not_on_package";
    RulingDiscardReason["SignalNotOnPackage"] = "signal_not_on_package";
    RulingDiscardReason["SignalRemoved"] = "signal_removed";
    RulingDiscardReason["SignalRenamed"] = "signal_renamed";
    RulingDiscardReason["SignalNameTaken"] = "signal_name_taken";
    RulingDiscardReason["SignalGainedPins"] = "signal_gained_pins";
    RulingDiscardReason["ColumnNotWritable"] = "column_not_writable";
    RulingDiscardReason["DependsOnDiscarded"] = "depends_on_discarded";
})(RulingDiscardReason || (exports.RulingDiscardReason = RulingDiscardReason = {}));
exports.RulingDiscardReasonSchema = z.nativeEnum(RulingDiscardReason);
exports.DiscardedRulingSchema = z.object({
    kind: exports.DiscardedRulingKindSchema,
    anchor: consensus_types_1.AnchorSchema.nullable(),
    rawValue: json_value_1.JsonValueSchema.nullable(),
    signalName: z.string().nullable(),
    reason: exports.RulingDiscardReasonSchema,
    renamedTo: z.string().nullable(),
});
//# sourceMappingURL=adjudication-discard.types.js.map